/**
 * Utility functions for PDF operations
 */

/**
 * Creates a download link for a PDF blob
 * @param {Blob} blob - PDF blob
 * @param {string} filename - Filename for download
 */
export const downloadPDF = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

/**
 * Shares a PDF using Web Share API if available, otherwise downloads
 * @param {Blob} blob - PDF blob
 * @param {string} filename - Filename
 * @param {string} title - Share title
 * @param {string} text - Share text
 */
export const sharePDF = async (blob, filename, title, text) => {
  // Check if Web Share API is available (mobile)
  if (navigator.share && navigator.canShare) {
    try {
      const file = new File([blob], filename, { type: 'application/pdf' });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({
          title,
          text,
          files: [file]
        });
        return true; // Successfully shared
      }
    } catch (error) {
      console.log('Sharing failed, falling back to download:', error);
    }
  }
  
  // Fallback to download
  downloadPDF(blob, filename);
  return false; // Used download fallback
};

/**
 * Formats a filename based on date, name and location
 * @param {string} datum - Date string (YYYY-MM-DD format)
 * @param {string} naam - Full name
 * @param {string} plaats - Location
 * @returns {string} - Formatted filename
 */
export const formatFilename = (datum, naam, plaats) => {
  const formattedDate = datum 
    ? datum.replace(/-/g, '') 
    : new Date().toISOString().slice(0,10).replace(/-/g, '');
  
  const voornaam = naam.split(' ')[0]; // Take first word as voornaam
  const plaatsnaam = plaats;
  
  return `${formattedDate}_${voornaam}_${plaatsnaam}.pdf`;
};